/**
 * @module Experince/Product-Selector
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

import {
  ByodDeviceData,
  NewSimData,
} from '@experience/shop/byod/interfaces/byod-landing.interface';
import { CMMOrImeiData } from '@experience/shop/product-selector/interfaces/product-selector.interface';
import { ObjectService } from '@support/state-object-hash-utilities/services/object.service';
export class ByodMappingModel {
  constructor() {}

  /**
   * Function used to map to sim details if coming from byod scenario
   */
  public static mapToSimDetails(simNumber: string): NewSimData {
    return {
      simNumber: simNumber,
    };
  }
  /**
   * Function used to map to Career Make Model or IMEI Object
   * @param {ByodDeviceData} careerMakeModelorImei
   * @param {ObjectService} objectService
   * @returns {CMMOrImeiData}
   */
  public static mapToCareerMakeModelOrImei(
    careerMakeModelorImei: ByodDeviceData,
    objectService: ObjectService
  ): CMMOrImeiData {
    if (
      objectService.get(careerMakeModelorImei, 'imeiData.imei') ||
      (objectService.get(careerMakeModelorImei, 'imeiData.imei') &&
        objectService.get(careerMakeModelorImei, 'deviceData.eid'))
    ) {
      return this.mapToImei(
        careerMakeModelorImei.imeiData.imei,
        careerMakeModelorImei.isSkipSelected,
        careerMakeModelorImei.eid
      );
    }
    return {
      isSkipSelected: objectService.get(careerMakeModelorImei, 'isSkipSelected'),
    };
  }
  /**
   * Function used to map to imei
   * @param {string} imei
   * @returns {CMMOrImeiData}
   */
  public static mapToImei(imei: string, isSkipSelected?: boolean, eId?: string): CMMOrImeiData {
    return {
      imei: imei,
      isSkipSelected,
      eid: eId,
    };
  }
}
